import { Component, computed, inject, input } from '@angular/core';
import { rxResourceFixed } from '@zayan-erp/shared';
import { DealOptionsService } from '../../../services/deal-options.service';
import { NameInitialsComponent } from '@zayan-erp/shared';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'addendum-logs',
  imports: [DatePipe, NameInitialsComponent],
  templateUrl: './addendum-logs.component.html'
})
export class AddendumLogsComponent {
  private readonly dealOptionsService = inject(DealOptionsService);

  readonly addendumId = input.required<string>();

  addendumLogsRxResource = rxResourceFixed({
    params: () => ({ optionId: this.addendumId() }),
    defaultValue: [],
    stream: ({ params }) => {
      return this.dealOptionsService.getDealOptionLogs(params.optionId);
    }
  });

  addendumLogs = computed(() => this.addendumLogsRxResource.value() ?? []);

  isDate(value: any): boolean {
    if (value.key?.toLowerCase().includes('date')) {
      if (!value.value || value.value === 'null' || value.value === '') return false;
      const date = new Date(String(value.value));
      return !isNaN(date.getTime()) && date.getFullYear() > 1900;
    }
    return false;
  }
}
